import { useEffect, useRef } from 'react';
import { useTranslation, Trans } from 'next-i18next';
import clsx from 'clsx';
import { useCountUp } from 'react-countup';

import { useViewportVisibility } from '@hooks/useViewportVisibility';
import { useMonthlyMessagesCountQuery } from '@api/hooks/useMonthlyMessagesCountQuery';

const DEFAULT_MESSAGES_COUNT = 510000;

export function MessagesLastMonth({ className }) {
  const { t: tt } = useTranslation('plans');

  const { data: messagesCountData, loading: messagesCountDataLoading } =
    useMonthlyMessagesCountQuery();

  const messagesCountRef = useRef(null);
  const { visible, attachTarget } = useViewportVisibility(true);
  const { update: updateCountUp } = useCountUp({
    ref: messagesCountRef,
    startOnMount: false,
    duration: 2.75,
    end: 0,
  });
  useEffect(() => {
    if (!messagesCountDataLoading && visible) {
      updateCountUp(messagesCountData || DEFAULT_MESSAGES_COUNT);
    }
  }, [messagesCountData, messagesCountDataLoading, updateCountUp, visible]);

  return (
    <section className={clsx(className)}>
      <h2 className="text-center text-[24px] font-bold mt-0 mb-[16px]">
        {tt('messages_last_month.title')}
      </h2>

      <p
        className={clsx(
          'text-center font-semibold m-0',
          !messagesCountDataLoading && 'hidden',
        )}
      >
        <span className="text-[22px] font-bold typing-dots">
          {tt('messages_last_month.loading')}
        </span>
      </p>

      <p
        className={clsx(
          'text-center font-semibold m-0',
          messagesCountDataLoading && 'hidden',
        )}
      >
        <Trans t={tt} i18nKey="messages_last_month.counter">
          ✉️{' '}
          <span
            ref={(node) => {
              messagesCountRef.current = node;
              attachTarget(node);
            }}
            className="text-[22px] font-bold"
          />{' '}
          +
        </Trans>
      </p>
    </section>
  );
}
